import {
  ROLE_PROOF_READER,
  ROLE_SYSTEM_ADMIN,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_LSP,
} from '@/utils/const.js';

export default [
  {
    path: '/documentation/add',
    name: 'documentation-add',
    component: () => import('@/views/documentation/documentation-add/index.vue'),
    meta: {
      title: 'Documentation add file',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
        ],
      },
    },
  },
  {
    path: '/documentation/:view?',
    name: 'documentation',
    component: () => import('@/views/documentation/index.vue'),
    meta: {
      title: 'Documentation',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/documentation/risk-analysis/aviation-and-transportation-technology',
    name: 'documentation-matrix',
    component: () => import('@/views/documentation/documentation-matrix/index.vue'),
    meta: {
      title: 'Documentation',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_SYSTEM_ADMIN,
        ],
      },
    },
  },
];
